import moment from "moment";
import { handleErrorApi } from "../../helpers/randoms";
import DiscapacidadService from "../../services/DiscapacidadService";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startFetchExcel } from "../../services/fetch/startFetch";
import { ESTADO_VALORIZACIONES_DISCAPACIDAD } from "../../utils/constants";

export const armarParametrosValorizaciones = (
  discapacidadFiltro,
  activosPorFecha,
  fechaDesde,
  fechaHasta
) => {
  let p1 = activosPorFecha ? `activosPorFecha=${activosPorFecha}` : ``;
  let p2 = discapacidadFiltro
    ? `&discapacidadFiltro=${discapacidadFiltro}`
    : ``;
  let p3 =
    fechaDesde && moment(fechaDesde).isValid()
      ? `&fechaDesde=${fechaDesde}`
      : ``;
  let p4 =
    fechaHasta && moment(fechaHasta).isValid()
      ? `&fechaHasta=${fechaHasta}`
      : ``;

  return `${p1}${p2}${p3}${p4}`;
};

const armarParametrosExcel = ({
  discapacidadFiltro,
  activosPorFecha,
  fechaDesde,
  fechaHasta,
}) => {
  let p1 = activosPorFecha ? `activosPorFecha=${activosPorFecha}` : ``;
  let p2 = discapacidadFiltro
    ? `&discapacidadFiltro=${discapacidadFiltro}`
    : ``;
  let p3 =
    fechaDesde && moment(fechaDesde).isValid()
      ? `&fechaDesde=${fechaDesde}`
      : ``;
  let p4 =
    fechaHasta && moment(fechaHasta).isValid()
      ? `&fechaHasta=${fechaHasta}`
      : ``;

  return `${p1}${p2}${p3}${p4}`;
};

export const setActivosPorFecha = (activoPorFecha) => async (dispatch) => {
  dispatch({
    type: types.discapacidadValorizacionesSetActivosPorFecha,
    payload: activoPorFecha,
  });
};

export const getValorizacionesDiscapacidad =
  (discapacidadFiltro = null, activosPorFecha, fechaDesde, fechaHasta) =>
  async (dispatch) => {
    dispatch({ type: types.discapacidadValorizacionesTraerStart });
    try {
      
      const response = await fetchConToken(
        `Discapacidad/ValorizacionesDiscapacidad?${armarParametrosValorizaciones(
          discapacidadFiltro,
          activosPorFecha,
          fechaDesde,
          fechaHasta
        )}`
      );
      let body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.discapacidadValorizacionesTraerSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al cargar las valorizaciones.",
        "Ha ocurrido un error. Intente nuevamente"
      );
      dispatch({ type: types.discapacidadValorizacionesTraerError });
    }
  };

export const editarValorizacionDiscapacidad = (idValorizacion, data) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const result = await DiscapacidadService.putValorizacion(
        idValorizacion,
        data
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadValorizacionesEditar,
          payload: {
            idValorizacion: idValorizacion,
            valor: data.valor,
          },
        });
        dispatch(startAlerta(`Valor Modificado`, "success", "Comando Exitoso"));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al editar valor",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

const baseUrl = process.env.REACT_APP_API_URL;
export const SubirArchivoExcel = (file, filtroExcel) => async (dispatch) => {

  dispatch(startSpinner());

  const url = `${baseUrl}/Discapacidad/Valorizaciones/CargaExcel`;
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;

  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
  }
  const formData = new FormData();
  formData.append("formFile", file);
  try {
    const result = await fetch(url, {
      method: "POST",
      body: formData,
      headers: httpHeaders,
    });
    const body = await result.json();
    if (result.ok) {
      dispatch(finishSpinner());
      dispatch(getValorizacionesDiscapacidad(filtroExcel.discapacidadFiltro === "" ? null : filtroExcel.discapacidadFiltro, 
      ESTADO_VALORIZACIONES_DISCAPACIDAD[filtroExcel.activosPorFecha],
      filtroExcel.fechaDesde, 
      filtroExcel.fechaHasta));
      dispatch(
        startAlerta(
          `Archivo subido correctamente`,
          "success",
          "Comando Exitoso"
        )
      );
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente",
      false
    );
  }
};

export const DescargarPlantillaExcel = (dispatch, parameters) => {
  dispatch(
    startFetchExcel(
      () =>
        fetchConToken(
          `Discapacidad/Valorizaciones/Excel?${armarParametrosExcel(
            parameters
          )}`
        ),
      "Discapacidad-Valores.xlsx"
    )
  );
};
